import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { FormFinancingKeys } from './types'

interface Schema {
    id: FormFinancingKeys
}

export const FormFinancingValue: {
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    layout: LayoutProps
}[] = [
    {
        input: {
            id: 'valorTotalDivida',
            label: 'Valor total da dívida',
            maskReplace: 'moeda',
            inputMode: 'numeric',
            maxLength: 15
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'valorParcela',
            label: 'Valor da parcela',
            maskReplace: 'moeda',
            inputMode: 'numeric',
            maxLength: 15
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'dataLiberacaoCredito',
            label: 'Data Liberação de crédito',
            placeholder: 'dd/mm/aaaa',
            type: 'date'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'ufLiberacaoCredito',
            label: 'UF Liberação de Crédito'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'municipioLiberacaoCredito',
            label: 'Município Liberação de Crédito'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'vencimentoPrimeiraParcela',
            label: 'Vencimento 1ª parcela',
            placeholder: 'dd/mm/aaaa',
            type: 'date'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'vencimentoUltimaParcela',
            label: 'Vencimento da última parcela',
            placeholder: 'dd/mm/aaaa',
            type: 'date'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    }
]
